var map = {
	"./pages/Error.vue": [
		6889,
		6889
	],
	"./pages/NewsFeed.vue": [
		42226,
		836,
		2226
	],
	"./pages/end/LolEnd.vue": [
		79092,
		836,
		683,
		4378,
		9092
	],
	"./pages/end/TftEnd.vue": [
		86377,
		836,
		683,
		4378,
		6377
	],
	"./pages/end/ValEnd.vue": [
		41473,
		836,
		683,
		4378,
		1473
	],
	"./pages/end/WrEnd.vue": [
		66539,
		836,
		683,
		4378,
		6539
	],
	"./pages/gameHome/LolHome.vue": [
		76186,
		836,
		683,
		30,
		5412,
		9491,
		6186
	],
	"./pages/gameHome/LoldocupHome.vue": [
		6925,
		836,
		683,
		30,
		8414,
		6925
	],
	"./pages/gameHome/ValorantHome.vue": [
		19724,
		836,
		683,
		30,
		5412,
		5411,
		9724
	],
	"./pages/gameHome/WrHome.vue": [
		17849,
		836,
		683,
		30,
		5412,
		7849
	],
	"./pages/landing/LandingHome.vue": [
		54517,
		4517
	],
	"./pages/lol/AcademyLanding.vue": [
		79279,
		836,
		9279
	],
	"./pages/lol/LolLeaderboard.vue": [
		21560,
		836,
		9491,
		1560
	],
	"./pages/loldocup/LoldocupEvent.vue": [
		8284,
		836,
		8284
	],
	"./pages/loldocup/LoldocupIntro.vue": [
		82628,
		836,
		8414,
		2628
	],
	"./pages/loldocup/LoldocupResult.vue": [
		52282,
		836,
		2282
	],
	"./pages/tftUniversityShowdown/TftUniversityShowdownHome.vue": [
		44915,
		836,
		683,
		30,
		5412,
		4915
	],
	"./pages/tftWeeklyCup/TftHome.vue": [
		32415,
		836,
		683,
		30,
		5412,
		2415
	],
	"./pages/tftWeeklyCup/TftIntro.vue": [
		7784,
		836,
		7784
	],
	"./pages/tftWeeklyCup/TftResult.vue": [
		525,
		836,
		525
	],
	"./pages/valorant/ShotValLanding.vue": [
		73410,
		836,
		3410
	],
	"./pages/valorant/ValorantLeaderboard.vue": [
		81342,
		836,
		1342
	],
	"./pages/wildRift/WariwariLanding.vue": [
		24523,
		836,
		4523
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12912;
module.exports = webpackAsyncContext;